import type { PlanType, TierLimits } from '../types';

export const API_VERSION = 'v1' as const;
export const API_BASE_PATH = `/api/${API_VERSION}` as const;

export const API_ROUTES = {
  GENERATE_QUESTIONS: `${API_BASE_PATH}/questions/generate`,
  SUBSCRIPTION_ME: `${API_BASE_PATH}/subscriptions/me`,
  SUBSCRIPTION_CANCEL: `${API_BASE_PATH}/subscriptions/cancel`,
  PAYMENT_INITIATE: `${API_BASE_PATH}/payments/initiate`,
  PAYMENT_HISTORY: `${API_BASE_PATH}/payments/history`,
  PAYMENT_IPN: `${API_BASE_PATH}/payments/ipn`,
} as const;

export const TIER_LIMITS: Record<PlanType, TierLimits> = {
  free_trial: { pdfsPerMonth: 1, maxWritten: 3, maxMCQ: 10 },
  pro_trial: { pdfsPerMonth: 20, maxWritten: 6, maxMCQ: 30 },
  pro: { pdfsPerMonth: 40, maxWritten: 6, maxMCQ: 30 },
  institution: { pdfsPerMonth: 1000, maxWritten: 100, maxMCQ: 100 },
};

export const PLAN_DURATIONS: Record<PlanType, number> = {
  free_trial: 14,
  pro_trial: 30,
  pro: 30,
  institution: 30,
};

export const PLAN_PRICES: Record<Exclude<PlanType, 'free_trial' | 'institution'>, number> = {
  pro_trial: 499,
  pro: 899,
};

export const PLAN_NAMES: Record<PlanType, string> = {
  free_trial: 'Free Trial',
  pro_trial: 'Pro Trial',
  pro: 'Pro',
  institution: 'Institution',
};

export const PURCHASABLE_PLANS = ['pro_trial', 'pro'] as const;
export type PurchasablePlan = (typeof PURCHASABLE_PLANS)[number];
